import vtkActor from './Actor';
import vtkActor2D from './Actor2D';
import vtkBufferObject from './BufferObject';
import vtkCamera from './Camera';
import vtkCellArrayBufferObject from './CellArrayBufferObject';
import vtkConvolution2DPass from './Convolution2DPass';
import './CubeAxesActor';
import vtkForwardPass from './ForwardPass';
import vtkFramebuffer from './Framebuffer';
import vtkGlyph3DMapper from './Glyph3DMapper';
import vtkHardwareSelector from './HardwareSelector';
import vtkHelper from './Helper';
import vtkImageMapper from './ImageMapper';
import vtkImageSlice from './ImageSlice';
import vtkPixelSpaceCallbackMapper from './PixelSpaceCallbackMapper';
import vtkPolyDataMapper from './PolyDataMapper';
import vtkPolyDataMapper2D from './PolyDataMapper2D';
import vtkRenderer from './Renderer';
import vtkRenderWindow from './RenderWindow';
import './ScalarBarActor';
import vtkShader from './Shader';
import vtkShaderCache from './ShaderCache';
import vtkShaderProgram from './ShaderProgram';
import vtkSkybox from './Skybox';
import vtkSphereMapper from './SphereMapper';
import vtkStickMapper from './StickMapper';
import vtkTexture from './Texture';
import vtkTextureUnitManager from './TextureUnitManager';
import vtkVertexArrayObject from './VertexArrayObject';
import vtkViewNodeFactory from './ViewNodeFactory';
import vtkVolume from './Volume';
import vtkVolumeMapper from './VolumeMapper';

export default {
  vtkActor,
  vtkActor2D,
  vtkBufferObject,
  vtkCamera,
  vtkCellArrayBufferObject,
  vtkConvolution2DPass,
  vtkForwardPass,
  vtkFramebuffer,
  vtkGlyph3DMapper,
  vtkHardwareSelector,
  vtkHelper,
  vtkImageMapper,
  vtkImageSlice,
  vtkPixelSpaceCallbackMapper,
  vtkPolyDataMapper,
  vtkPolyDataMapper2D,
  vtkRenderer,
  vtkRenderWindow,
  vtkShader,
  vtkShaderCache,
  vtkShaderProgram,
  vtkSkybox,
  vtkSphereMapper,
  vtkStickMapper,
  vtkTexture,
  vtkTextureUnitManager,
  vtkVertexArrayObject,
  vtkViewNodeFactory,
  vtkVolume,
  vtkVolumeMapper,
};
